
window.onload = (event) => {
  console.log("page is fully loaded");
    const hook = setInterval(()=>{
        let hulkDiv = document.querySelector('.hulkapps-volumes');
        console.log('tu');
        if (hulkDiv){
            clearInterval(hook);

            document.getElementById('card-list-button').type = 'submit';

        }
    },150)
    setTimeout(()=>{
        clearInterval(hook);
    },10000)
};